/* eslint-disable no-case-declarations */
import { EntityAction, EntityState, EntityActionType } from './types';
import { resolve } from './util';
import resolveCustomEntityStoreReducer from './reducer-map';

const initialState = {
  characterslnf: [],
  characterswoodPieces: [],
  characterswdt: [],
  loading: false,
  requestCounter: 0,
  errors: [],
  licenses: [],
  licensesById: {},
  workbooks: [],
  workbooksById: {},
  featureToggles: {},
  featureTogglesByName: {},
  resources: [],
  resoucesById: {},
  favoriteResources: [],
  favoriteResourcesById: {},
  characters: [],
  charactersById: {},
  pdf: null,
  workbookContent: null,
  activePdfPageDetails: null,
  pageDetails: {},
  lastWorkbook: null,
  lastTeachersGuide: null,
  clickAways: [],
  filterGroups: [],
  filterGroupsByFilter: {},
  lessonPlan: null,
  teachingOrder: [],
  updatedProductConfig: null,
  updatedTeachingOrder: null,
  customTeachingOrderCreated: null,
  readlessonPlan: null,
  assignments: [],
  assignmentsById: {},
  assignmentDetail: null,
  assignmentAttempt: null,
  assignmentAttemptMessages: [],
  classrooms: [],
  classroomsById: {},
  students: [],
  studentsById: {},
  userAssignments: null,
  productConfig: null,
  supportResources: null
} as any;

const getLoading = counter => counter >= 1;
const getCounter = (counter, incOrDec) => {
  const newRequestCounter = counter + incOrDec;

  return newRequestCounter < 1 ? 0 : newRequestCounter;
};
const getRequestState = (counter: number, incOrDec = 1) => {
  const requestCounter = getCounter(counter, incOrDec);

  return {
    requestCounter,
    loading: getLoading(requestCounter)
  };
};

const entityStoreReducer = (state: EntityState = initialState, action: EntityAction) => {
  switch (action.type) {
    case EntityActionType.REQUEST_IN_FLIGHT: {
      const { requestCounter, loading } = getRequestState(state.requestCounter, 1);

      if (action.requestActionType) {
        return resolveCustomEntityStoreReducer({ ...state, requestCounter, loading }, action);
      }

      return {
        ...state,
        loading,
        requestCounter
      };
    }
    case EntityActionType.REQUEST_SUCCESS: {
      const { requestCounter, loading } = getRequestState(state.requestCounter, -1);

      if (action.requestActionType) {
        return resolveCustomEntityStoreReducer({ ...state, requestCounter, loading }, action);
      }

      return {
        ...state,
        loading,
        requestCounter,
        errors: [],
        ...action,
        ...resolve(state, action)
      };
    }
    case EntityActionType.REQUEST_ERROR: {
      const { requestCounter, loading } = getRequestState(state.requestCounter, -1);

      if (action.requestActionType) {
        return resolveCustomEntityStoreReducer({ ...state, requestCounter, loading }, action);
      }

      return {
        ...state,
        loading,
        requestCounter,
        errors: [...state.errors, ...action.data]
      };
    }
    case EntityActionType.CANCEL_DOWNLOAD_REQUEST: {
      const { requestCounter, loading } = getRequestState(state.requestCounter, -1);

      if (action.requestType) {
        return resolveCustomEntityStoreReducer({ ...state, requestCounter, loading }, action);
      }

      return {
        ...state,
        loading,
        requestCounter
      };
    }
    case EntityActionType.CANCEL_LOADING: {
      return {
        ...state,
        loading: false
      };
    }
    case EntityActionType.RESET_KEY: {
      const { key } = action;

      return { ...state, [key]: initialState[key] };
    }
    default:
      return state;
  }
};

export default entityStoreReducer;
